import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import InvoiceManage from './pages/InvoiceManage';
import AdminLayout from './layouts/AdminLayout';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Orders from './pages/Orders';
import Settings from './pages/Settings';
import Providers from './pages/Providers';
import Affiliates from './pages/Affiliates';
import SystemSettings from './pages/SystemSettings';
import PaymentSettings from './pages/PaymentSettings';
import ReferralCampaigns from './pages/ReferralCampaigns';
import Feedbacks from './pages/Feedbacks';
import CustomerServiceConfig from './pages/CustomerServiceConfig';
import CompanyNews from './pages/CompanyNews';
import MiniProgramConfig from './pages/MiniProgramConfig';
import APIKeys from './pages/APIKeys';
import SystemMaintenance from './pages/SystemMaintenance';
import Plugins from './pages/Plugins';
import Presets from './pages/Presets';
import Batches from './pages/Batches';
import RateLimits from './pages/RateLimits';
import RouteRouter from './pages/RouteRouter';
import OpenRouterModels from './pages/OpenRouterModels';
import ProviderHealthMonitor from './pages/ProviderHealthMonitor';
import PaymentReturn from './pages/PaymentReturn';
import RealNameAuth from './pages/RealNameAuth';
import SMSConfig from './pages/SMSConfig';
import OperatorAuth from './pages/OperatorAuth';
import SeedanceConfig from './pages/SeedanceConfig';
import TokeaseConfig from './pages/TokeaseConfig';
import AgentManagement from './pages/AgentManagement';
import AppConfig from './pages/AppConfig';

function App() {
  const token = localStorage.getItem('admin_token');

  return (
    <Routes>
      <Route
        path="/login"
        element={token ? <Navigate to="/" /> : <Login />}
      />
      {/* 支付返回页面 - 公开访问，不需要登录 */}
      <Route path="/payment-return" element={<PaymentReturn />} />
      {/* 运营商授权 - 独立密码，不在导航显示 */}
      <Route path="/operator-auth" element={<OperatorAuth />} />
      <Route
        path="/"
        element={token ? <AdminLayout /> : <Navigate to="/login" />}
      >
        <Route index element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="orders" element={<Orders />} />
        <Route path="api-keys" element={<APIKeys />} />
        <Route path="providers" element={<Providers />} />
        <Route path="affiliates" element={<Affiliates />} />
        <Route path="agents" element={<AgentManagement />} />
        <Route path="referral-campaigns" element={<ReferralCampaigns />} />
        <Route path="feedbacks" element={<Feedbacks />} />
        <Route path="realname-auth" element={<RealNameAuth />} />
        <Route path="sms-config" element={<SMSConfig />} />
        <Route path="system-settings" element={<SystemSettings />} />
        <Route path="payment-settings" element={<PaymentSettings />} />
        <Route path="invoices" element={<InvoiceManage />} />
        <Route path="customer-service-config" element={<CustomerServiceConfig />} />
        <Route path="company-news" element={<CompanyNews />} />
        <Route path="mini-program-config" element={<MiniProgramConfig />} />
        <Route path="settings" element={<Settings />} />
        <Route path="system-maintenance" element={<SystemMaintenance />} />
        <Route path="plugins" element={<Plugins />} />
        <Route path="presets" element={<Presets />} />
        <Route path="batches" element={<Batches />} />
        <Route path="rate-limits" element={<RateLimits />} />
        <Route path="route-router" element={<RouteRouter />} />
        <Route path="openrouter-models" element={<OpenRouterModels />} />
        <Route path="provider-health" element={<ProviderHealthMonitor />} />
        <Route path="seedance-config" element={<SeedanceConfig />} />
        <Route path="tokease-config" element={<TokeaseConfig />} />
        <Route path="app-config" element={<AppConfig />} />
      </Route>
    </Routes>
  );
}

export default App;
